<template>
  <div>
    <!-- 头部 start -->
    <top />
    <!-- banner start -->
    <div class="banner">
      <div class="hidden-sm-and-down">
        <video src="@/assets/video/banner.mp4" autoplay="autoplay" loop="loop" muted playsinline="true"
          webkit-playsinline="true" x5-video-player-type="h5"></video>
      </div>
      <img class="banner-slogan wd-slogan" src="@/assets/images/banner/img_fontslogan.png" alt="">
    </div>
    <!-- banner end  -->
    <!-- 申请入口 -->
    <apply-entry></apply-entry>
    <!-- 文都简介 start -->
    <wd-profile id="module1"></wd-profile>

    <!-- 文都文化 -->
    <wd-culture id="module2"></wd-culture>
    <!-- 文都集团 -->
    <wd-business></wd-business>

    <!-- 项目介绍 -->
    <wd-project id="module3"></wd-project>
    <!-- 项目优势 -->
    <pro-advantage></pro-advantage>

    <!-- 文都风采 -->
    <company-show id="module4"></company-show>

    <!--合作流程  -->
    <cooperate-process id="module5"></cooperate-process>

    <!-- 总部支持 -->
    <wd-support id="module6"></wd-support>
    <!-- 合作条件 -->
    <cooperate-condition></cooperate-condition>
    <bottom />

  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import {useRoute} from 'vue-router'
import Top from "@/components/common/Top.vue";
import Bottom from "@/components/common/Bottom.vue";
import ApplyEntry from "@/components/home/ApplyEntry.vue";
import WdProfile from "@/components/home/WdProfile.vue";
import WdCulture from "@/components/home/WdCulture.vue";
import WdBusiness from "@/components/home/WdBusiness.vue";
import ProAdvantage from "@/components/home/ProAdvantage.vue";
import CooperateProcess from "@/components/home/CooperateProcess.vue";
import CooperateCondition from "@/components/home/CooperateCondition.vue";
import WdProject from "@/components/home/WdProject.vue";
import WdSupport from "@/components/home/WdSupport.vue";
import CompanyShow from "@/components/home/CompanyShow.vue";

export default defineComponent({
  name: "home",
  setup() {
    const route=useRoute()
    const goAnchor=(domId)=>{
        document.getElementById(domId).scrollIntoView(true)
    }
    onMounted(()=>{
        //从表单、联系我们跳转过来
        let moduleId=localStorage.getItem('moduleId')
        if(moduleId){
            goAnchor(moduleId)
            localStorage.setItem('moduleId','')
        }
    })

    return { 
        goAnchor
    };
  },
  components: {
    Bottom,
    ApplyEntry,
    WdProfile,
    WdCulture,
    WdBusiness,
    ProAdvantage,
    CooperateProcess,
    CooperateCondition,
    WdProject,
    WdSupport,
    CompanyShow,
    Top
  }
});
</script>

<style lang="scss" scoped type="text/scss">
/* banner*/
.small-banner {
  width: 100%;
}

/* apply-entry */
.apply-entry {
  position: relative;
  padding: 40px;
  background: #fff;
  margin-top: -64px;
  z-index: 3;

  .apply-icon {
    float: left;
    width: 80px;
    height: 80px;
    margin-right: 24px;
  }
  .apply-invite {
    float: left;
    font-size: 14px;
    color: #869099;
    h2 {
      padding: 8px 0;
      font-size: 24px;
      color: #1b1d1f;
    }
    .apply-tel {
      color: #0099ff;
    }
  }
  .apply-right {
    overflow: hidden;
  }
  .entry-btn {
    // float:right;
    display: block;
    width: 88px;
    height: 48px;
    background: #0099ff;
    border-radius: 24px;
    line-height: 48px;
    color: #fff;
    text-align: center;
    font-weight: bold;
    margin-top: 8px;
  }
}
</style>
